import { Product } from "@transfr-inc/dashboard-components/constants";

import heroOne from "../../public/images/banner/hero-one.png";
import trekBannerImage from "../../public/images/banner/trek-hero.png";
import {
  ProfessionalLearningProduct,
  TrekTrainProduct,
} from "@components/custom/dropdowns/product-dropdown-list";

import { getProduct } from "@transfr-inc/dashboard-components/utils";

export const SimPassProducts = [Product.TS, Product.CE, Product.PROG];

export const hasAnyProducts = (data, products) =>
  products.some((product) =>
    data instanceof Array ? data?.includes(product) : data === product
  );

export function getProductBanner(productID) {
  switch (productID) {
    case Product.TS:
    case Product.CE:
      return heroOne;
    case Product.TRK:
      return trekBannerImage;
    case Product.PROG:
      return heroOne;
  }
}

export function resolveCurrentProduct(classroom) {
  if (classroom?.isProfessionalLearning) return ProfessionalLearningProduct;
  const ids = classroom?.products ?? [];
  const hasTS = ids.includes(Product.TS);
  const hasTRK = ids.includes(Product.TRK);
  const hasCE = ids.includes(Product.CE);
  if (hasTS && hasTRK && hasCE) return TrekTrainProduct;
  if (hasTRK && hasCE) return getProduct(Product.CE_TRK);
  return ids.length > 0 ? getProduct(ids[0]) : null;
}

export function getProductIcon(productID) {
  switch (productID) {
    case Product.TS:
    case Product.CE:
      return "fa-solid fa-bullseye-arrow";
    case Product.TRK:
      return "fa-regular fa-person-hiking";
    case Product.PROG:
      return "fa-regular fa-helmet-safety";
  }
}
